import styled from "styled-components";

export const AddressAndPepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  margin-bottom: 72px;

  @media (max-width: 480px) {
    gap: 24px;
    margin-bottom: 32px;
  }
`;
